module.exports = __webpack_public_path__ + "img/profile_box_expert_info.ce188ed9.svg";